/* Stories do Vidget no celular: toque na metade direita do vídeo avança, na esquerda volta;
   segurar o dedo pausa e soltar continua.
   O Vidget cancela o touchstart do player, e no celular isso impede o clique que as zonas de toque esperam.
   Aqui um toque rápido e parado na zona dispara esse clique. Arrastar fica com o Vidget. */
(function () {
  if (window.__mbVidgetTap) return;
  window.__mbVidgetTap = true;
  var HOLD_MS = 200;
  var start = null;
  // no celular a navegação é pelo toque: esconde as setas (no computador elas ficam)
  var css = document.createElement('style');
  css.textContent = '@media (pointer: coarse){#vidget__container .vidget__navigation{display:none !important}}' +
    // rodapé enxuto: sem a caixa escura, título pequeno à esquerda e botão em pílula à direita, para tapar menos o produto
    '#vidget__container .vidget__article{background:none !important;box-shadow:none !important;border:0 !important;backdrop-filter:none !important;-webkit-backdrop-filter:none !important;' +
      'padding:0 !important;left:12px !important;right:12px !important;bottom:14px !important;display:flex !important;flex-direction:row !important;align-items:center !important;justify-content:space-between !important;gap:8px;min-height:0 !important}' +
    '#vidget__container .vidget__article-content{flex:1 1 auto;min-width:0;padding:0 !important;margin:0 !important;display:flex !important;justify-content:flex-start !important;text-align:left !important;min-height:0 !important}' +
    '#vidget__container .vidget__article-info{text-align:left !important;align-items:flex-start !important;margin:0 !important;padding:0 !important}' +
    '#vidget__container .vidget__article-image:not([src]),#vidget__container .vidget__article-image[src=""]{display:none !important}' +
    '#vidget__container .vidget__article-title{font-size:12px !important;line-height:1.2 !important;margin:0 !important;color:#fff !important;text-shadow:0 1px 3px rgba(0,0,0,.7);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '#vidget__container .vidget__article-description:empty,#vidget__container .vidget__article-price:empty{display:none !important}' +
    '#vidget__container .vidget__article-button{flex:0 0 auto;width:auto !important;margin:0 0 0 auto !important;padding:9px 16px !important;border-radius:999px !important;font-size:13px !important;box-shadow:0 2px 8px rgba(0,0,0,.35)}' +
    // segurando o dedo: vídeo limpo, sem botões, barra e textos
    '#vidget__container .vidget__controls>*{transition:opacity .2s}' +
    '#vidget__container.mb-hold .vidget__controls>*{opacity:0 !important;pointer-events:none}';
  document.head.appendChild(css);
  function videoAtual() {
    var c = document.getElementById('vidget__container');
    return c && c.querySelector('video');
  }
  function modoLimpo(on) {
    var c = document.getElementById('vidget__container');
    if (c) c.classList.toggle('mb-hold', on);
  }
  function cancelaPausa(s) {
    clearTimeout(s.timer);
    if (s.paused) { s.paused.play(); s.paused = null; }
    modoLimpo(false);
  }
  document.addEventListener('touchstart', function (e) {
    if (start) cancelaPausa(start);
    var zone = e.target.closest && e.target.closest('.vidget__tap-zone');
    if (!zone || e.touches.length > 1) { start = null; return; }
    var t = e.touches[0];
    var s = start = { zone: zone, x: t.clientX, y: t.clientY, time: Date.now(), paused: null };
    s.timer = setTimeout(function () {
      var v = videoAtual();
      if (v && !v.paused) { v.pause(); s.paused = v; modoLimpo(true); }
    }, HOLD_MS);
  }, { capture: true, passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!start) return;
    var t = e.touches[0];
    // virou arrasto: devolve o vídeo e deixa o gesto com o Vidget
    if (Math.abs(t.clientX - start.x) > 12 || Math.abs(t.clientY - start.y) > 12) { cancelaPausa(start); start = null; }
  }, { capture: true, passive: true });
  document.addEventListener('touchend', function (e) {
    if (!start) return;
    var s = start;
    start = null;
    clearTimeout(s.timer);
    if (s.paused) { s.paused.play(); modoLimpo(false); return; }
    var t = e.changedTouches[0];
    var parado = Math.abs(t.clientX - s.x) < 12 && Math.abs(t.clientY - s.y) < 12;
    // evita disparar duas vezes se o navegador também gerar o clique
    if (parado && Date.now() - s.time < HOLD_MS && !(s.zone.__mbTap > Date.now() - 400)) {
      s.zone.__mbTap = Date.now();
      s.zone.click();
    }
  }, { capture: true, passive: true });
  document.addEventListener('touchcancel', function () {
    if (start) { cancelaPausa(start); start = null; }
  }, { capture: true, passive: true });
  document.addEventListener('click', function (e) {
    var zone = e.target.closest && e.target.closest('.vidget__tap-zone');
    if (zone && zone.__mbTap > Date.now() - 400 && e.isTrusted) { e.stopPropagation(); e.preventDefault(); }
  }, true);

  function fechaStory() {
    var c = document.getElementById('vidget__container');
    var x = c && c.querySelector('.vidget__btn--close');
    if (x) x.click();
  }

  // botão "Escolher meu número" (link com #escolher-numero no Vidget): fecha o story e leva ao seletor de tamanho da cor aberta
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#vidget__container a[href*="#escolher-numero"]');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    var origem = videoAberto();
    ga('story_cta_click', origem);
    // depois do botão: acompanha se escolhe o número e se segue para a compra (uma vez cada, por 10 min)
    ctaStory = { info: origem, t: Date.now(), tamanho: false, compra: false };
    fechaStory();
    setTimeout(function () {
      var p = document.querySelector('.pdp-picker');
      if (!p) return;
      p.scrollIntoView({ behavior: 'smooth', block: 'center' });
      p.classList.add('mb-picker-flash');
      setTimeout(function () { p.classList.remove('mb-picker-flash'); }, 1600);
    }, 250);
  }, true);
  css.textContent += '.mb-picker-flash{animation:mbPickerFlash 1.6s ease}' +
    '@keyframes mbPickerFlash{0%,100%{box-shadow:0 0 0 0 rgba(184,67,15,0)}30%,70%{box-shadow:0 0 0 3px rgba(184,67,15,.55)}}';

  // GA4: story_open, story_view, story_cta_click e story_close, com produto e vídeo
  var produto = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || location.pathname;
  function nomeArq(src) {
    return decodeURIComponent(String(src || '').split(/[?#]/)[0].split('/').pop() || '');
  }
  function infoVideo(src) {
    var arq = nomeArq(src), b = null;
    document.querySelectorAll('.vidget-embedded-bubble').forEach(function (el) {
      if (b) return;
      var m = el.querySelector('video,img,source');
      if (m && nomeArq(m.getAttribute('src')) === arq) b = el;
    });
    return {
      video_id: b ? b.dataset.videoId : '',
      video_name: arq.replace(/\.(mp4|mov|webm)$/i, '').slice(0, 40),
      story_index: b ? Number(b.dataset.videoIndex) + 1 : 0,
      story_total: document.querySelectorAll('.vidget-embedded-bubble').length
    };
  }
  function ga(evento, extra) {
    if (typeof window.gtag !== 'function') return;
    var p = { product_handle: produto };
    for (var k in extra) p[k] = extra[k];
    window.gtag('event', evento, p);
  }
  var sessao = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.vidget-embedded-bubble');
    if (!b) return;
    var m = b.querySelector('video,img,source'), i = infoVideo(m && m.getAttribute('src'));
    sessao = { vistos: 0, ultimo: '', idx: i.story_index };
    ga('story_open', i);
  }, true);
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!sessao || !v.closest || !v.closest('#vidget__container')) return;
    var src = nomeArq(v.currentSrc || v.src);
    if (src === sessao.ultimo) return;
    var i = infoVideo(src);
    i.direction = !sessao.ultimo ? 'abriu' : i.story_index > sessao.idx ? 'avancou' : 'voltou';
    sessao.ultimo = src; sessao.idx = i.story_index; sessao.vistos++;
    ga('story_view', i);
  }, true);
  function videoAberto() {
    var v = videoAtual();
    return infoVideo(v && (v.currentSrc || v.src));
  }
  function fimSessao() {
    if (!sessao) return;
    ga('story_close', { videos_vistos: sessao.vistos });
    sessao = null;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#vidget__container .vidget__btn--close')) fimSessao();
  }, true);

  // compartilhar: link da página com ?story=<id do vídeo>; quem abre o link já cai no story aberto nesse vídeo
  function avisa(txt) {
    var t = document.createElement('div');
    t.textContent = txt;
    t.style.cssText = 'position:fixed;left:50%;bottom:90px;transform:translateX(-50%);z-index:2147483647;background:rgba(17,22,15,.92);color:#fff;' +
      'font:600 13px/1.2 sans-serif;padding:10px 16px;border-radius:999px;pointer-events:none';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 1800);
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#vidget__container .vidget__btn--copy')) return;
    e.preventDefault();
    e.stopPropagation();
    var i = videoAberto();
    var url = location.origin + location.pathname + '?story=' + encodeURIComponent(i.video_id) + '&utm_source=story_share&utm_medium=social';
    var titulo = (document.querySelector('h1') || {}).textContent || document.title;
    if (navigator.share) {
      navigator.share({ title: titulo.trim(), url: url }).then(function () { ga('story_share', { video_id: i.video_id, video_name: i.video_name, story_index: i.story_index, metodo: 'share' }); }, function () {});
    } else {
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        avisa('Link do story copiado');
        ga('story_share', { video_id: i.video_id, video_name: i.video_name, story_index: i.story_index, metodo: 'copiar' });
      }, function () { window.prompt('Copie o link do story:', url); });
    }
  }, true);
  var pedido = new URLSearchParams(location.search).get('story');
  if (pedido !== null) {
    var tentativas = 0;
    var abre = setInterval(function () {
      var bolhas = document.querySelectorAll('.vidget-embedded-bubble');
      if (!bolhas.length) { if (++tentativas > 40) clearInterval(abre); return; }
      clearInterval(abre);
      var alvo = document.querySelector('.vidget-embedded-bubble[data-video-id="' + String(pedido).replace(/[^0-9a-z_-]/gi, '') + '"]') || bolhas[0];
      ga('story_shared_open', { video_id: alvo.dataset.videoId || '', achou_video: alvo.dataset.videoId === pedido ? 'sim' : 'nao' });
      alvo.click();
    }, 400);
  }

  var ctaStory = null;
  function ctaAtivo() { return ctaStory && Date.now() - ctaStory.t < 600000; }
  function comOrigem(extra) {
    var p = {};
    for (var k in ctaStory.info) p[k] = ctaStory.info[k];
    for (var j in extra) p[j] = extra[j];
    p.segundos_desde_cta = Math.round((Date.now() - ctaStory.t) / 1000);
    return p;
  }
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!ctaAtivo() || ctaStory.tamanho || r.type !== 'radio' || !r.closest || !r.closest('.pdp-picker')) return;
    ctaStory.tamanho = true;
    ga('story_size_select', comOrigem({ size: r.value }));
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button.mb-fx-add, button.btn-clay');
    if (!b || !ctaAtivo() || ctaStory.compra) return;
    ctaStory.compra = true;
    var r = document.querySelector('.pdp-picker input[type=radio]:checked');
    ga('story_add_to_cart', comOrigem({ size: r ? r.value : '', button: /comprar/i.test(b.textContent) ? 'comprar_agora' : 'sacola' }));
  }, true);

  // arrastar para baixo fecha o story (o Vidget usaria para voltar; voltar agora é tocar na esquerda). Para cima segue com o Vidget
  var sw = null;
  document.addEventListener('touchstart', function (e) {
    var c = e.target.closest && e.target.closest('#vidget__container .vidget__video-container');
    sw = c && e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
  }, { capture: true, passive: true });
  document.addEventListener('touchend', function (e) {
    if (!sw) return;
    var t = e.changedTouches[0], dx = t.clientX - sw.x, dy = t.clientY - sw.y;
    sw = null;
    if (dy > 80 && Math.abs(dx) < dy) { e.stopPropagation(); fechaStory(); }
  }, { capture: true });
})();
